import * as React from 'react'

const googleContext: {
  googleMapKey: string
} = {
  googleMapKey: ''
}

export const GoogleMapContext = React.createContext(googleContext)
